module.exports = __webpack_public_path__ + "img/shadow--horizontal.cb38ee6.webp";